import { Behance } from "@styled-icons/boxicons-logos/Behance"
import { Github } from "@styled-icons/boxicons-logos/Github"
import { Linkedin } from "@styled-icons/boxicons-logos/Linkedin"

const Icons = {
  Behance,
  Github,
  Linkedin,
}

export default Icons
